import React from 'react';
const SvgFileThumbnail = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg viewBox="0 0 100 100" width="1em" height="1em" {...props}>
      <path fill="#5C7896" d="M11 3v94h78V23H69V3H11z" />
      <path fill="#769CC2" d="M69 3l20 20H69V3z" />
      <path opacity={0.3} fill="#1B3F63" d="M69 23h20v20L69 23z" />
    </svg>
  );
});
export default SvgFileThumbnail;
SvgFileThumbnail.iconName = 'file-thumbnail';
SvgFileThumbnail.displayName = 'SvgFileThumbnail';
